import { AppEvent, AppEventType, BotStatusAppEvent, BotStatusUpdateActivity } from '@sa/cassius-contract';

const EVENT_FROM_ID = 'bot';

interface AppEventFromBot extends AppEvent<AppEventType> {
  from: typeof EVENT_FROM_ID;
  value: AppEventValue;
}

export type AppEventValue = { type: AppEventType };

export function createBotStatusAppEvent(activity: BotStatusUpdateActivity): BotStatusAppEvent {
  return {
    value: activity.value.status,
    from: EVENT_FROM_ID,
    type: 'webchat/status'
  };
}

export function createAnyAppEvent(value: AppEventValue): AppEventFromBot {
  return {
    type: value.type,
    from: EVENT_FROM_ID,
    value
  };
}
